import React from "react";
import { Box } from "@mui/material";
import {
  getPodPrintingTypeBadgeStyle,
  type PodBadgeStyle,
} from "../../../models/PodOrder/PodPrintingType";
import { getPodOrderProgressStageBadgeStyle } from "../../../models/PodOrder/PodOrderProgressStage";

type BadgeVariant = "pill" | "tag";

const PodCellBadge = ({
  style,
  variant = "pill",
  label,
}: {
  style: PodBadgeStyle;
  variant?: BadgeVariant;
  label?: string;
}) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      px: variant === "pill" ? 1.75 : 1.25,
      py: variant === "pill" ? 0.5 : 0.35,
      borderRadius: variant === "pill" ? "999px" : "6px",
      fontSize: variant === "pill" ? "0.75rem" : "0.72rem",
      lineHeight: variant === "pill" ? 1.2 : undefined,
      fontWeight: 600,
      whiteSpace: "nowrap",
      color: style.color,
      backgroundColor: style.backgroundColor,
    }}
  >
    {label ?? style.label}
  </Box>
);

export const PodOrderPrintingTypeBadge: React.FC<{ name: string | null }> = ({ name }) => (
  <PodCellBadge
    style={getPodPrintingTypeBadgeStyle(name)}
    variant="tag"
    label={name ?? undefined}
  />
);

export const PodOrderProgressStageBadge: React.FC<{ status: string }> = ({ status }) => (
  <PodCellBadge style={getPodOrderProgressStageBadgeStyle(status)} variant="pill" />
);
